import React from "react";
import { Gradient } from "../externalComponents/Gradient";

export default () => {
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData("application/reactflow", nodeType);
    event.dataTransfer.effectAllowed = "move";
  };

  return (
    <aside className="bg-grey p-5 rounded-lg drop-shadow-md relative overflow-hidden">
      <div className="h-full w-full pointer-events-none opacity-20 blur-xl -z-10 absolute bg-gradient-to-br from-yellow to-pink" />
      <ul className="flex flex-wrap justify-between gap-1">
        <li
          className="dndnode dndnode-template"
          onDragStart={(event) => onDragStart(event, "template")}
          draggable
        >
          Template
        </li>
        <li
          className="dndnode dndnode-message"
          onDragStart={(event) => onDragStart(event, "message")}
          draggable
        >
          Answer
        </li>
        <li
          className="dndnode dndnode-consent"
          onDragStart={(event) => onDragStart(event, "consent")}
          draggable
        >
          Optin / Optout
        </li>
        <li
          className="dndnode dndnode-wait"
          onDragStart={(event) => onDragStart(event, "wait")}
          draggable
        >
          Wait...
        </li>
        <li
          className="dndnode dndnode-tag"
          onDragStart={(event) => onDragStart(event, "tag")}
          draggable
        >
          Add tag
        </li>
        <li
          className="dndnode dndnode-condition"
          onDragStart={(event) => onDragStart(event, "condition")}
          draggable
        >
          Condition
        </li>
        <li
          className="dndnode dndnode-webhook"
          onDragStart={(event) => onDragStart(event, "webhook")}
          draggable
        >
          Webhook
        </li>
        <li
          className="dndnode dndnode-ai"
          onDragStart={(event) => onDragStart(event, "ai")}
          draggable
        >
          AI chat
        </li>
        <li
          className="dndnode dndnode-note"
          onDragStart={(event) => onDragStart(event, "note")}
          draggable
        >
          Note
        </li>
      </ul>
    </aside>
  );
};
